import { ApiAsset, ApiDistributionAlert } from '../../../api/_legacy/generated-api'
import { MasterDetail, Section } from '../../../components/core-v2'
import { TablePaginationParams } from '../../../components/core-v2/molecules/table-pagination'
import { FundsSearchFilter } from '../state/funds-slice'
import FundDetailsPanel from './fund-details-panel'
import { FundsPanel } from './funds-master-panel'

export type FundsLayoutProps = {
  filter: FundsSearchFilter
  funds: ApiAsset[]
  fundsAlerts: ApiDistributionAlert[]
  isLoading: boolean
  onFilterChange: (updatedFilter: FundsSearchFilter) => void
  onPaginationChange: (updatedPagination: TablePaginationParams) => void
  paginationParams: TablePaginationParams
  totalNumFunds: number
}

const FundsLayout = ({
  filter,
  funds,
  fundsAlerts,
  isLoading,
  onFilterChange,
  onPaginationChange,
  paginationParams,
  totalNumFunds
}: FundsLayoutProps) => (
  <MasterDetail
    detailChildren={
      <Section type="quaternary">
        <FundDetailsPanel />
      </Section>
    }
    masterChildren={
      <Section type="primary">
        <FundsPanel
          funds={funds}
          fundsAlerts={fundsAlerts}
          isLoading={isLoading}
          paginationParams={paginationParams}
          searchFilter={filter}
          totalNumAccounts={totalNumFunds}
          onPaginationChange={onPaginationChange}
          onSearch={onFilterChange}
        />
      </Section>
    }
    width="normal"
  />
)

export default FundsLayout
